const genTempId = () => Date.now() + Math.random();

export const newAutomation = (automationAction) => ({
  tempId: genTempId(),
  name: "",
  active: true,
  oncePerContact: true,
  trigger: "contact_created",
  conditionLogic: "and",
  automationConditions: [newCondition()],
  automationActions: [automationAction],
});

export const newCondition = () => ({
  tempId: genTempId(),
  contactFieldId: "",
  operator: "",
  value: "",
});
